import { render, staticRenderFns } from "./CouponJoychat.vue?vue&type=template&id=622e3a9d&scoped=true"
import script from "./CouponJoychat.vue?vue&type=script&lang=js"
export * from "./CouponJoychat.vue?vue&type=script&lang=js"
import style0 from "./CouponJoychat.vue?vue&type=style&index=0&id=622e3a9d&prod&lang=less&scoped=true"
import style1 from "./CouponJoychat.vue?vue&type=style&index=1&id=622e3a9d&prod&lang=scss"
import style2 from "./CouponJoychat.vue?vue&type=style&index=2&id=622e3a9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622e3a9d",
  null
  
)

export default component.exports